import React, { useEffect, useState, useMemo } from 'react';
import TR from './../../Trans';
import TrackListItem from './../items/TrackListItem';
import IntervalService from './../../services/intervals';
import MuvikaService from './../../services/muvika';
import { useMediaQuery } from 'react-responsive';
import { checkIfMobile } from '../../services/screen';
import AddPerformance from './../dialogs/AddPerformance';
import { Views } from './../../enums/enums';
import TrackAlreadyQueue from '../dialogs/TrackAlreadyQueue';
import AddPerformanceSongbook from './../dialogs/AddPerformanceSongbook';
import AddBackgroundMusic from '../dialogs/AddBackgroundMusic';
import ChangeTrackPerformance from './../dialogs/ChangeTrackPerformance';
import ChangeTrackPerformanceSongbook from '../dialogs/ChangeTrackPerformanceSongbook';
import SameSingerDialog from '../dialogs/SameSingerDialog';
import sessionStore from './../../stores/session';
import songbookSessionStore from './../../stores/songbookSession';
import performanceStore from '../../stores/performance';
import singersStore from '../../stores/singers';
import navigationStore from './../../stores/navigation';
import playerStore from '../../stores/player';
import searchStore from './../../stores/search';
import messageStore from './../../stores/message';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import musicPlayerStore from '../../stores/musicPlayer';
import bgPerformanceStore from '../../stores/bgPerformance';

const sameSingerQueuedAlreadyError = 100002;

function TrackListContainer(props) {

  const [isAddPerformanceOpen, setIsAddPerformanceOpen] = useState(false);
  const [isAddPerformanceSongbookOpen, setIsAddPerformanceSongbookOpen] = useState(false);
  const [isAddBackgroundMusicOpen, setIsAddBackgroundMusicOpen] = useState(false);
  const [isChangeTrackPerformanceOpen, setIsChangeTrackPerformanceOpen] = useState(false);
  const [isChangeTrackPerformanceSongbookOpen, setIsChangeTrackPerformanceSongbookOpen] = useState(false);
  const [isSameSingerDialogOpen, setIsSameSingerDialogOpen] = useState(false);
  const [chosenTrack, setChosenTrack] = useState({});
  const [chosenTrackBackgroundMusic, setChosenTrackBackgroundMusic] = useState({});
  const [chosenTrackSongbook, setChosenTrackSongbook] = useState({});
  const [chosenSingerSongbook, setChosenSingerSongbook] = useState({});
  const [chosenPitchSongbook, setChosenPitchSongbook] = useState({});
  const [sameSingerErrorMsg, setSameSingerErrorMsg] = useState('');
  const [isTrackAlreadyQueueOpen, setIsTrackAlreadyQueueOpen] = useState(false);
  const [chosenPlayList, setChosenPlayList] = useState(null);

  const sessionToken = props.isSongbook ? songbookSessionStore((state) => state.sessionToken) : sessionStore((state) => state.sessionToken);
  const isSongbookPublicMode = props.isSongbook ? songbookSessionStore((state) => state.isSongbookPublicMode) : false;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const addPerformanceToPlayQueue = performanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const playLists = performanceStore((state) => state.playLists);
  const getPlayLists = performanceStore((state) => state.getPlayLists);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const changeTrackPerformance = performanceStore((state) => state.changeTrackPerformance);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setPerformanceToBeChanged = performanceStore((state) => state.setPerformanceToBeChanged);
  const searchNavBarInputRef = searchStore((state) => state.searchNavBarInputRef);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const musicPlayLists = bgPerformanceStore((state) => state.playLists);
  const getBackgroundMusicPlayLists = bgPerformanceStore((state) => state.getPlayLists);
  const addPerformanceToMusicPlayQueue = bgPerformanceStore((state) => state.addPerformanceToPlayQueue);
  const addToBackgroundMusicPlayList = bgPerformanceStore((state) => state.addPerformanceToPlayList);
  const playQueue = performanceStore((state) => state.playQueue);
  const musicPlayQueue = bgPerformanceStore((state) => state.playQueue);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
    if (!playLists && !props.isSongbook) {
      getPlayLists(sessionToken);
    }
    if (!musicPlayLists && !props.isSongbook) {
      getBackgroundMusicPlayLists(sessionToken);
    }
  }, []);

  const handleOpenAddPerformance = (track) => {
    MuvikaService.getLastPerformance(sessionToken, track.track_id)
      .then(function (res) {
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          if (res.data.data.profile_id) {
            track.last_pitch = res.data.data.pitch;
            track.last_singer_id = res.data.data.profile_id;
          }
          setChosenTrack(track);
          setIsAddPerformanceOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleOpenAddPerformanceSongbook = (track) => {
    MuvikaService.getLastPerformance(sessionToken, track.track_id)
      .then(function (res) {
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          if (res.data.data.profile_id) {
            track.last_pitch = res.data.data.pitch;
            track.last_singer_id = res.data.data.profile_id;
          }
          setChosenTrackSongbook(track);
          setIsAddPerformanceSongbookOpen(true);
        }
      })
      .catch(function () { });
  };

  const handleOpenTrackAlreadyQueue = (track) => {
    setIsTrackAlreadyQueueOpen(true);
  };

  const handleCloseTrackAlreadyQueue = () => {
    setIsTrackAlreadyQueueOpen(false);
  };

  const handleConfirmDoubleTrack = () => {
    if (chosenPlayList) {
      addToBackgroundMusicPlayList(sessionToken, chosenTrackBackgroundMusic, singers[0], chosenPlayList.id);
    }
    handleCloseTrackAlreadyQueue();
  };

  const handleOpenAddBackgroundMusic = (track) => {
    setChosenTrackBackgroundMusic(track);
    setIsAddBackgroundMusicOpen(true);
  };

  const handleCloseAddPerformance = () => {
    setIsAddPerformanceOpen(false);
  };

  const handleCloseAddPerformanceSongbook = () => {
    setIsAddPerformanceSongbookOpen(false);
  };

  const handleCloseAddBackgroundMusic = () => {
    setIsAddBackgroundMusicOpen(false);
  };

  const handleCloseSameSingerDialog = () => {
    setIsSameSingerDialogOpen(false);
  };

  const handleSameSingerConfirmation = () => {
    MuvikaService.createSongRequest(sessionToken, "add", chosenTrackSongbook.track_id, chosenSingerSongbook.id, chosenPitchSongbook, [])
      .then(function (res) {
        //console.log(res);
        if (res.data.error) {
          setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          setIsSameSingerDialogOpen(false);
        } else {
          setIsSameSingerDialogOpen(false);
          setIsAddPerformanceSongbookOpen(false);
        }
      })
      .catch(function () { });
  };

  const handleOpenChangePerformance = (track) => {
    if (performanceToBeChanged) {
      MuvikaService.getLastPerformance(sessionToken, track.track_id)
        .then(function (res) {
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (res.data.data.profile_id) {
              track.last_pitch = res.data.data.pitch;
            }
            track.last_singer_id = performanceToBeChanged.profile.id;
            setChosenTrack(track);
            setIsChangeTrackPerformanceOpen(true);
          }
        })
        .catch(function () { });
    }
  };

  const handleCloseChangeTrackPerformance = () => {
    setIsChangeTrackPerformanceOpen(false);
  };

  const handleOpenChangePerformanceSongbook = (track) => {
    if (performanceToBeChanged) {
      if (performanceToBeChanged) {
        MuvikaService.getLastPerformance(sessionToken, track.track_id)
          .then(function (res) {
            if (res.data.error) {
              setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              if (res.data.data.profile_id) {
                track.last_pitch = res.data.data.pitch;
              }
              track.last_singer_id = performanceToBeChanged.profile.id;
              setChosenTrackSongbook(track);
              setIsChangeTrackPerformanceSongbookOpen(true);
            }
          })
          .catch(function () { });
      }
    }
  };

  const handleCloseChangeTrackPerformanceSongbook = () => {
    setIsChangeTrackPerformanceSongbookOpen(false);
  };

  const handleChangeTrackPerformance = (singerProfile, pitch) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      changeTrackPerformance(sessionToken, chosenTrack, singerProfile, pitch);
      setIsChangeTrackPerformanceOpen(false);
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleChangeTrackPerformanceSongbook = (pitch) => {
    if (pitch >= -3 && pitch <= 3) {
      MuvikaService.createSongRequest(sessionToken, "edit", chosenTrackSongbook.track_id, performanceToBeChanged.profile.id, pitch, [performanceToBeChanged.unique_id])
        .then(function (res) {
          //console.log(res);
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            setPerformanceToBeChanged(null);
            setIsChangeTrackPerformanceSongbookOpen(false);
            if (isSongbookPublicMode) {
              setSearchQuery("");
              searchNavBarInputRef.current.value = "";
            }
          }
        })
        .catch(function () { });
    }
  };

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleAddPerformance = (singerProfile, pitch, playList, toPos, isManual, playNow = false, isSongbookQueue = false) => {
    console.log("handleAddPerformance", playList, isSongbookQueue);
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      if (playList) {
        addPerformanceToPlayList(sessionToken, chosenTrack, singerProfile, pitch, playList.id, toPos);
        setIsAddPerformanceOpen(false);
      } else {
        if (isSongbookQueue) {
          MuvikaService.createSongRequest(sessionToken, "add", chosenTrack.track_id, singerProfile.id, pitch, [])
            .then(function (res) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            })
            .catch(function () { });
          setIsAddPerformanceOpen(false);
        } else {
          setIsAutoPlayOn(settingsStore.getState().settings?.autoplay_enabled);
          addPerformanceToPlayQueue(sessionToken, chosenTrack, singerProfile, pitch, toPos, isManual, playNow);
          setIsAddPerformanceOpen(false);
        }
      }
      if (toPos == 0 && playNow) {
        IntervalService.clearAllIntervals();
        setIsAutoPlayOn(false);
        setIsSwitching(true);
        let isMobile = checkIfMobile();
        if (isMobile) {
          goToView(Views.Blank);
          setMobilePlayerVisible(true);
        }
      }
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleAddPerformanceSongbook = (singerProfile, pitch) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      MuvikaService.createSongRequest(sessionToken, "add", chosenTrackSongbook.track_id, singerProfile.id, pitch, [])
        .then(function (res) {
          if (res.data.error) {
            if (res.data.error.code === sameSingerQueuedAlreadyError) {
              setSameSingerErrorMsg(res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              setChosenPitchSongbook(pitch);
              setChosenSingerSongbook(singerProfile);
              setIsSameSingerDialogOpen(true);
            } else {
              setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            }
          } else {
            //console.log("OK");
            setIsAddPerformanceSongbookOpen(false);
            setMessage(sessionToken, TR.cm_song_request_sent);
            setSearchQuery("");
            searchNavBarInputRef.current.value = "";
          }
        })
        .catch(function () { });
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleAddBackgroundMusic = (playList, pos, playNow) => {
    console.log("playList", playList);
    if (playList) {
      let isAlreadyOnPlayList = false;
      for (var i = 0; i < playList.items.length; i++) {
        let track = playList.items[i].track;
        console.log("playList", playList, track.track_id, chosenTrackBackgroundMusic.track_id);
        if (track.track_id === chosenTrackBackgroundMusic.track_id) {
          isAlreadyOnPlayList = true;
          break;
        }
      }
      if (isAlreadyOnPlayList) {
        setChosenPlayList(playList);
        console.log("playList", "already");
        handleOpenTrackAlreadyQueue();
      } else {
        setChosenPlayList(null);
        addToBackgroundMusicPlayList(sessionToken, chosenTrackBackgroundMusic, singers[0], playList.id);
      }
    } else {
      addPerformanceToMusicPlayQueue(sessionToken, chosenTrackBackgroundMusic, singers[0], pos, false, playNow);
    }
  };

  const isFuzzy = (track) => {
    if (track) {
      if (track.flags) {
        return track.flags.includes("fuzzy");
      }
    }
    return false;
  };

  const trackListBackgroundMusic = useMemo(() => {
    if (props.tracks) {
      let isFuzzyShown = false;
      return props.tracks.map((track, index) => {
        if (isFuzzy(track) && !isFuzzyShown) {
          isFuzzyShown = true;
          return <div key={track.track_id}>
            <p>
              {TR.cm_no_exact_match_showing_similar}
            </p>
            <TrackListItem
              isSongbook={props.isSongbook}
              isBackgroundMusic={true}
              key={track.track_id}
              track={track}
              onAddBackgroundMusic={(e) => {
                e.preventDefault();
                handleOpenAddBackgroundMusic(track);
              }}
            />
          </div>;
        }
        return <div key={track.track_id}><TrackListItem
          isBackgroundMusic={true}
          key={track.track_id}
          track={track}
          onAddBackgroundMusic={(e) => {
            e.preventDefault();
            handleOpenAddBackgroundMusic(track);
          }}
        /></div>;
      }
      );
    }
  }, [props.tracks]);

  const trackListSongbook = useMemo(() => {
    if (props.tracks) {
      let isFuzzyShown = false;
      return props.tracks.map((track, index) => {
        if (isFuzzy(track) && !isFuzzyShown) {
          isFuzzyShown = true;
          return <div key={track.track_id}>
            <p>
              {TR.cm_no_exact_match_showing_similar}
            </p>
            <TrackListItem
              isSongbook={true}
              key={track.track_id}
              track={track}
              isNewTracks={props.isNewTracks}
              onAddPerformance={(e) => {
                e.preventDefault();
                handleOpenAddPerformanceSongbook(track);
              }}
              onChangeTrackPerformance={(e) => {
                e.preventDefault();
                handleOpenChangePerformanceSongbook(track);
              }}
            />
          </div>;
        }
        return <div key={track.track_id}><TrackListItem
          isSongbook={true}
          key={track.track_id}
          track={track}
          isNewTracks={props.isNewTracks}
          onAddPerformance={(e) => {
            e.preventDefault();
            handleOpenAddPerformanceSongbook(track);
          }}
          onChangeTrackPerformance={(e) => {
            e.preventDefault();
            handleOpenChangePerformanceSongbook(track);
          }}
        /></div>;
      }
      );
    }
  }, [props.tracks]);

  const trackListNormal = useMemo(() => {
    if (props.tracks) {
      let isFuzzyShown = false;
      return props.tracks.map((track, index) => {
        if (isFuzzy(track) && !isFuzzyShown) {
          isFuzzyShown = true;
          return <div key={track.track_id}>
            <p>
              {TR.cm_no_exact_match_showing_similar}
            </p>
            <TrackListItem
              key={track.track_id}
              highlight={props.highlight}
              isSongbook={props.isSongbook}
              isOnFavoritesView={props.isOnFavoritesView}
              track={track}
              isNewTracks={props.isNewTracks}
              onAddPerformance={(e) => {
                e.preventDefault();
                handleOpenAddPerformance(track);
              }}
              onChangeTrackPerformance={(e) => {
                e.preventDefault();
                handleOpenChangePerformance(track);
              }}
            />
          </div>;
        }
        return <div key={track.track_id}>
          <TrackListItem
            isSongbook={props.isSongbook}
            highlight={props.highlight}
            isOnFavoritesView={props.isOnFavoritesView}
            track={track}
            isNewTracks={props.isNewTracks}
            onAddPerformance={(e) => {
              e.preventDefault();
              handleOpenAddPerformance(track);
            }}
            onChangeTrackPerformance={(e) => {
              e.preventDefault();
              handleOpenChangePerformance(track);
            }}
          /></div>;
      }
      );
    }
  }, [props.tracks]);

  const trackList = () => {
    console.log("render again");
    if (props.isSongbook) {
      return trackListSongbook;
    } else if (props.isBackgroundMusic) {
      return trackListBackgroundMusic;
    } else {
      console.log("render again", props.tracks);
      return trackListNormal;
    }
  };

  const renderChangeTrackDialog = () => {
    if (performanceToBeChanged) {
      if (props.isSongbook) {
        return <ChangeTrackPerformanceSongbook
          open={isChangeTrackPerformanceSongbookOpen}
          onClose={handleCloseChangeTrackPerformanceSongbook}
          track={chosenTrackSongbook}
          performance={performanceToBeChanged}
          onChangeTrackPerformance={handleChangeTrackPerformanceSongbook}
        />;
      } else {
        return <ChangeTrackPerformance
          open={isChangeTrackPerformanceOpen}
          onClose={handleCloseChangeTrackPerformance}
          track={chosenTrack}
          performance={performanceToBeChanged}
          onChangeTrackPerformance={handleChangeTrackPerformance}
          singers={singers}
        />;
      }
    }
  };

  const renderAddDialog = () => {
    if (props.isSongbook) {
      return <AddPerformanceSongbook
        open={isAddPerformanceSongbookOpen}
        onClose={handleCloseAddPerformanceSongbook}
        onAddPerformance={handleAddPerformanceSongbook}
        track={chosenTrackSongbook}
        singers={singers}
      />;
    } else if (props.isBackgroundMusic) {
      return <AddBackgroundMusic
        open={isAddBackgroundMusicOpen}
        onClose={handleCloseAddBackgroundMusic}
        onAddBackgroundMusic={handleAddBackgroundMusic}
        track={chosenTrackBackgroundMusic}
        singers={singers}
        playQueue={musicPlayQueue}
        playLists={musicPlayLists}
      />;
    } else {
      return <AddPerformance
        open={isAddPerformanceOpen}
        onClose={handleCloseAddPerformance}
        onAddPerformance={handleAddPerformance}
        track={chosenTrack}
        singers={singers}
        playLists={playLists}
        playQueue={playQueue}
      />;
    }
  };

  return (
    <div>
      <TrackAlreadyQueue
        open={isTrackAlreadyQueueOpen}
        onClose={handleCloseTrackAlreadyQueue}
        onConfirmation={handleConfirmDoubleTrack}
      />
      <SameSingerDialog
        open={isSameSingerDialogOpen}
        onClose={handleCloseSameSingerDialog}
        onConfirmation={handleSameSingerConfirmation}
        errorMsg={sameSingerErrorMsg}
      />
      {renderAddDialog()}
      {renderChangeTrackDialog()}
      {trackList()}
    </div>
  );
}

export default TrackListContainer;